import { doc, serverTimestamp, setDoc, getDoc, collection, query, where, getDocs, getFirestore } from "firebase/firestore";
import { initializeApp } from 'firebase/app';
import { v4 as uuidv4 } from "uuid";
import { firebaseConfig } from "./firebase";
import { getBrowser, getUnixTime, setDeviceType } from "./util";

// 書き込み用のFirestoreインスタンス（フル版）
const app = initializeApp(firebaseConfig);
const writeDb = getFirestore(app);

export const userLogging = (functionName: String, content: Object, user: any) => {
    const jsonUserData = JSON.parse(user.userData);
    const screen = `縦:${window.innerHeight}px 横:${window.innerWidth}px`;
    const data: any = {
        access_time_unixtime: getUnixTime(),
        application_name: "location-counter",
        user_name: jsonUserData.email,
        function_name: functionName,
        content: content,
        device: setDeviceType(),
        screen,
        browser: getBrowser(),
        update_date: {
            update_date: serverTimestamp(),
            update_user: jsonUserData.email,
        },
    };
    writeFirestoreDoc("users_log", uuidv4(), data);
};

/**
 * firestoreに書き込みを行う
 */
const writeFirestoreDoc = (collectionName: string, docId: string, data: any) => {
    try {
        setDoc(doc(writeDb, collectionName, docId), data);
    } catch (error) {
        console.log(error);
    }
};
